<template>
  <div>
    <div class="page-header clear-filter" style="max-height: 10000px;">
      <parallax class="page-header-image" style="background-color:#183648;"></parallax>
      <div class="container" id="top">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-12">
            <a href="https://medium.com/league-of-kingdoms-eng/land-development-101-bc59ded957f" target="_blank">
              <card data-aos="fade-left">
                <div class="row" style="padding: 10px;">
                  <div class="col-lg-4">
                    <img v-lazy="'https://miro.medium.com/max/1400/1*_8Tx40nFD0HCwalIOB96JQ.png'" />
                  </div>
                  <div class="col-lg-8">
                    <h3 class="title" style="text-align: left; color: #000;">Land Development 101</h3>
                    <h5 class="description" style="text-align: left; color: #000;">How to develop your tokenized estates<br/>
We already covered what the land tokens are and why we want them.<br/>
For this post, we will deep dive into HOW we can utilize them to enjoy the game and earn rewards.</h5>
                  </div>                
                </div>
              </card>
            </a>
            <a href="https://medium.com/league-of-kingdoms-eng/land-presale-54dc997b71f3" target="_blank">
              <card data-aos="fade-left">
                <div class="row" style="padding: 10px;">
                  <div class="col-lg-4">
                    <img v-lazy="'https://miro.medium.com/max/1400/1*zof6faNgPwNjkHwh47tBeg.png'" />
                  </div>
                  <div class="col-lg-8">
                    <h3 class="title" style="text-align: left; color: #000;">LAND PRESALE</h3>
                    <h5 class="description" style="text-align: left; color: #000;">We learned previously about the LoK land system. For this story, we are excited to announce more detail about the upcoming presale of the Land token assets!!</h5>
                  </div>                
                </div>
              </card>
            </a>
            <a href="https://medium.com/league-of-kingdoms-eng/land-introduction-31a1b75b4866" target="_blank">
              <card data-aos="fade-left">
                <div class="row" style="padding: 10px;">
                  <div class="col-lg-4">
                    <img v-lazy="'https://miro.medium.com/max/1400/1*phIs3eJrG_xxMBl4oC9oUQ.png'" />
                  </div>
                  <div class="col-lg-8">
                    <h3 class="title" style="text-align: left; color: #000;">LAND Introduction</h3>
                    <h5 class="description" style="text-align: left; color: #000;">Allodial title of digital estates that grows its value<br/>
This blog post will introduce the detail of the most fundamental and<br/>
essential layer of the ‘League of Kingdoms’ ecosystem, the LANDs.<br/>
This post will cover below:<br/>
History of property ownership</h5>
                  </div>                
                </div>
              </card>
            </a>
            <a href="https://medium.com/league-of-kingdoms-eng/pre-registration-event-72d470ef6bd6" target="_blank">
              <card data-aos="fade-left">
                <div class="row" style="padding: 10px;">
                  <div class="col-lg-4">
                    <img v-lazy="'https://miro.medium.com/max/1400/1*XbJlAwuXeMGjlOp5WaMwyg.png'" />
                  </div>
                  <div class="col-lg-8">
                    <h3 class="title" style="text-align: left; color: #000;">PRE-REGISTRATION EVENT!</h3>
                    <h5 class="description" style="text-align: left; color: #000;">Register now and secure massive gifts🎁!<br/>
This post covers below:
1st event! Pre-register with your email and secure your $30 USD valued gifts on launch!!
2nd event! Invite your friends and get amazing gifts!!
Pre-registration event procedure & instruction</h5>
                  </div>                
                </div>
              </card>
            </a>
            <a href="https://medium.com/league-of-kingdoms-eng/introducing-league-of-kingdoms-649727747ee5" target="_blank">
              <card data-aos="fade-left">
                <div class="row" style="padding: 10px;">
                  <div class="col-lg-4">
                    <img v-lazy="'https://miro.medium.com/max/1400/1*lZUZo9BybgBlYR8C1GKxNQ.png'" />
                  </div>
                  <div class="col-lg-8">
                    <h3 class="title" style="text-align: left; color: #000;">Introducing ‘League of Kingdoms’</h3>
                    <h5 class="description" style="text-align: left; color: #000;">The first multi-chain MMO Strategy Game<br/>
This post will cover the below topics:<br/>
Brief Game Introduction — MMO Strategy game on Blockchain.<br/>
Concepts of gameplay on the League of Kingdoms’s ecosystem<br/>
Bird's eye view of the League of kingdoms ecology</h5>
                  </div>                
                </div>
              </card>
            </a>
            <a href="https://medium.com/league-of-kingdoms-eng/why-we-build-a-strategy-game-cc15d7b5edb7" target="_blank">
              <card data-aos="fade-left">
                <div class="row" style="padding: 10px;">
                  <div class="col-lg-4">
                    <img v-lazy="'https://miro.medium.com/max/1400/0*2SkfMpJHQHUf5jGE'" />
                  </div>
                  <div class="col-lg-8">
                    <h3 class="title" style="text-align: left; color: #000;">Why we build a Strategy game</h3>
                    <h5 class="description" style="text-align: left; color: #000;">featuring our thoughts on decentralized gaming.<br/>
2019 was a bleak year for the blockchain gaming industry.<br/>Despite hypes of 2018, the industry ended with flat growth and very little traction.</h5>
                  </div>                
                </div>
              </card>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Parallax, Card } from "@/components";

export default {
  name: "media",
  bodyClass: "media-page",
  components: {
    Card,
    Parallax
  }
};
</script>
<style></style>
